/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 */

import React from "react";
import PropTypes from "prop-types";
import { useStaticQuery, graphql } from "gatsby";

import Header from "./navbar/header";
import Footer from "./footer";
import Section from "./section";
import EmergencyMessage from "./emergency-message";
// import "./layout.css"

const Layout = ({ children, isIndexPage }) => {
  const data = useStaticQuery(graphql`
    query LayoutQuery {
      gaiaWebsite {
        emergency_message_title
        emergency_message
        newsletter_message
        contact_phones
        contact_email
      }
      huvilat: gaiaPage(name: { eq: "Huvilat" }) {
        url
        child_pages {
          name
          url
          child_pages {
            name
            url
          }
        }
      }
      huoneistot: gaiaPage(name: { eq: "Lomahuoneistot" }) {
        url
        child_pages {
          name
          url
        }
      }

      lomaohjelmaa: gaiaPage(name: { eq: "Lomaohjelmaa" }) {
        url
        child_pages {
          name
          url
          child_pages {
            name
            url
          }
        }
      }

      palvelut: gaiaPage(name: { eq: "Palvelut" }) {
        url
        child_pages {
          name
          url
          child_pages {
            name
            url
          }
        }
      }

      footer: gaiaPage(name: { eq: "Footer" }) {
        child_pages {
          name
          url
          target_url
          type
        }
      }
    }
  `);
  const huvilat = {
    type: "dropdown",
    to: data.huvilat.url,
    title: "Huvilat",
    items: [],
  };

  const huoneistot = {
    type: "dropdown",
    to: data.huoneistot.url,
    title: "Huoneistot",
    items: [],
  };

  const lomaohjelmaa = {
    type: "dropdown",
    to: data.lomaohjelmaa.url,
    title: "Lomaohjelmaa",
    items: [],
  };

  const palvelut = {
    type: "dropdown",
    to: data.palvelut.url,
    title: "Palvelut",
    items: [],
  };

  for (const page of data.huvilat.child_pages) {
    let items = null;
    if (page.child_pages) {
      items = [];
      for (const child_page of page.child_pages) {
        items.push({ title: child_page.name, to: child_page.url });
      }
    }
    huvilat.items.push({ title: page.name, to: page.url, items });
  }

  for (const page of data.huoneistot.child_pages) {
    huoneistot.items.push({ title: page.name, to: page.url });
  }

  for (const page of data.lomaohjelmaa.child_pages) {
    let items = null;
    if (page.child_pages) {
      items = [];
      for (const child_page of page.child_pages) {
        items.push({ title: child_page.name, to: child_page.url });
      }
    }
    lomaohjelmaa.items.push({ title: page.name, to: page.url, items });
  }

  for (const page of data.palvelut.child_pages) {
    let items = null;
    if (page.child_pages) {
      items = [];
      for (const child_page of page.child_pages) {
        items.push({ title: child_page.name, to: child_page.url });
      }
    }
    palvelut.items.push({ title: page.name, to: page.url, items });
  }

  const headerLinks = [
    huvilat,
    huoneistot,
    lomaohjelmaa,
    palvelut,
    // {
    //   type: "dropdown",
    //   title: "Omat sivut",
    //   items: [
    //     {
    //       title: "Kirjaudu sivuille",
    //       to: "/",
    //     },
    //     {
    //       title: "Rekisteröidy",
    //       to: "/",
    //     },
    //   ],
    // },
    // { type: "simple", title: "Kirjaudu", to: "/" },
    { type: "simple", title: "Autovuokraus", to: "/car-rental" },
  ];

  let emergency_message;
  if (
    !process.env.GATSBY_GAIA_FORCE_HIDE_EMERGENCY_MESSAGE &&
    data.gaiaWebsite.emergency_message.length > 0
  ) {
    emergency_message = (
      <Section padding={0} margin={2}>
        <EmergencyMessage
          heading={data.gaiaWebsite.emergency_message_title}
          text={data.gaiaWebsite.emergency_message}
        />
      </Section>
    );
  }

  return (
    <>
      <Header headerLinks={headerLinks} isIndexPage={isIndexPage}></Header>
      {emergency_message}
      {children}
      <Footer
        footerLinks={data.footer.child_pages}
        newsletterformMsg={data.gaiaWebsite.newsletter_message}
        contactPhones={data.gaiaWebsite.contact_phones}
        contactEmail={data.gaiaWebsite.contact_email}
      ></Footer>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
